function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-2{fill:#3f8624;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Amazon-Elastic-Block-Store-EBS_Snapshot_light-bg");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Working"
}, React.createElement("path", {
  className: "cls-2",
  d: "M37.25,8.19H12.88a1,1,0,0,1-.92-.6,1,1,0,0,1,.18-1.08l4.33-4.69a1,1,0,0,1,.74-.32H32.92a1,1,0,0,1,.73.32L38,6.51a1,1,0,0,1,.19,1.08A1,1,0,0,1,37.25,8.19Zm-22.09-2H35L32.48,3.5H17.65Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M38.25,13.75h-2V11.94H13.88v1.81h-2V10.94a1,1,0,0,1,1-1H37.25a1,1,0,0,1,1,1Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M25,48.5c-5,0-12.43-1.12-12.55-4.19L9.11,19.47a1,1,0,0,1,2-.39C11.41,20.4,17,22.31,25,22.31s13.6-1.91,14-3.23a1,1,0,0,1,2,.39L37.57,44.31c0,1.09-1,2-2.76,2.71a17.91,17.91,0,0,1-2.35.7A34.22,34.22,0,0,1,25,48.5ZM11.46,22l3,22.15s0,.09,0,.14C14.71,45,18.92,46.5,25,46.5a32,32,0,0,0,7-.73,15.07,15.07,0,0,0,2.06-.61c1.34-.53,1.5-.95,1.5-.95a.45.45,0,0,1,0-.11l3-22.16c-3.28,1.7-9.26,2.37-13.55,2.37S14.75,23.64,11.46,22Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M25,24.31c-5.88,0-15-1.26-15.87-4.72l0-.12,0-.31c0-.05,0-.09,0-.13,0-3.47,8.25-5.81,16-5.81S41,15.56,41,19v.13l0,.31,0,.12C40,23.05,30.9,24.31,25,24.31ZM11.08,19.13c.46,1.31,6,3.18,13.93,3.18s13.48-1.87,13.93-3.18L39,19c-.14-1.15-5.52-3.76-13.95-3.76S11.2,17.83,11.07,19Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M40.74,34.51c-2.3,0-7-1.34-16.17-5.85l.88-1.8c6,2.95,13.12,5.76,15.23,5.77a11.4,11.4,0,0,0-2.55-1.74L38,30.83l1-1.75.11.06c2.48,1.37,3.63,2.4,3.82,3.45a1.63,1.63,0,0,1-.35,1.34A2.28,2.28,0,0,1,40.74,34.51Zm.38-1.95Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M25,29.63a1.87,1.87,0,1,1,1.87-1.87A1.87,1.87,0,0,1,25,29.63Zm0-2a.13.13,0,0,0-.13.13c0,.15.27.15.27,0A.13.13,0,0,0,25,27.63Z"
}));

var SvgAwsEbsVolume = function SvgAwsEbsVolume(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsEbsVolume, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-EBS_Volume.b1ed9ee9.svg";
export { ForwardRef as ReactComponent };